"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./bootstrap");
var vue_1 = __importDefault(require("vue"));
var App_vue_1 = __importDefault(require("./components/App.vue"));
var router_1 = __importDefault(require("./router"));
var store_1 = __importDefault(require("./store"));
/**
 * Create app instance.
 */
var app = new vue_1.default({
    el: "#app",
    components: { App: App_vue_1.default },
    router: router_1.default,
    store: store_1.default
});
exports.default = app;
